import { useIntl } from 'react-intl';
import { SectionHeading } from '@ets/design-system';

import { useDispatch, useRequiredParams } from '_common/hooks';
import { openAndUpdateModal } from '_common/modals/ModalsSlice';

const PublicLinkHeading = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { id } = useRequiredParams<{ id: ObjectId }>();

  return (
    <SectionHeading
      size="l"
      title={intl.formatMessage({ id: 'settings.publicLink.publicLink' })}
      firstAction={{
        onClick: () => {
          dispatch(
            openAndUpdateModal({
              modal: 'PublicLinkModal',
              data: {
                objectId: id,
                mode: 'create',
              },
            }),
          );
        },
        variant: 'primary',
        children: intl.formatMessage({ id: 'settings.publicLink.newPublicLink' }),
      }}
      testId="public-link"
    />
  );
};

export default PublicLinkHeading;
